import { TENANT_DETAILS } from "../../utils/types";

const initialState = {
  tenantDetails: {}
};

const tenantReducer = (state = initialState, action) => {
  switch (action.type) {
    case TENANT_DETAILS: {
      return {
        ...state,
        tenantDetails: action.payload,
      };
    }
    default:
      return state;
  }
};
export default tenantReducer;